import React, { useEffect, useState } from 'react';
import { Globe2, Trophy } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

export const PartnerLeaderboard = ({ isEs, dark = true }) => {
  const [data, setData] = useState(null);
  useEffect(() => {
    fetch(`${API}/api/affiliates/leaderboard`).then((r) => r.json()).then(setData).catch(() => {});
  }, []);
  if (!data) return null;
  const c = isEs
    ? { title: 'Leaderboard mundial de partners', sub: 'Los partners con más restaurantes activados, en todo el mundo.',
        empty: 'El programa acaba de abrir — los primeros partners que cierren clientes aparecerán aquí. Sé el partner fundador de tu ciudad.',
        customers: 'clientes', countries: 'países', perMonth: '/mes' }
    : { title: 'Worldwide partner leaderboard', sub: 'The partners with the most activated restaurants, across the globe.',
        empty: 'The program just opened — the first partners to close customers will show up here. Be the founding partner of your city.',
        customers: 'customers', countries: 'countries', perMonth: '/mo' };
  const medal = (i) => (i === 0 ? '🥇' : i === 1 ? '🥈' : i === 2 ? '🥉' : `${i + 1}`);
  const box = dark ? 'border-white/10 bg-white/[0.04]' : 'border-neutral-200 bg-white';
  const txt = dark ? 'text-white' : 'text-neutral-900';
  const sub = dark ? 'text-neutral-500' : 'text-neutral-500';
  return (
    <div className={`mt-6 rounded-2xl border p-6 ${box}`} data-testid="aff-leaderboard">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="flex items-center gap-2 text-[11px] uppercase tracking-wider text-[#FF9B4A] font-bold">
          <Trophy className="w-4 h-4" /> {c.title}
        </p>
        {data.countries.length > 0 && (
          <p className={`flex items-center gap-1.5 text-[11.5px] ${sub}`}>
            <Globe2 className="w-3.5 h-3.5 text-[#FF9B4A]" /> {data.partners_total} partners · {data.countries.length} {c.countries}
          </p>
        )}
      </div>
      <p className={`mt-1 text-[12px] ${sub}`}>{c.sub}</p>
      {data.top.length === 0 ? (
        <p className={`mt-4 text-[13px] ${sub}`} data-testid="aff-leaderboard-empty">{c.empty}</p>
      ) : (
        <div className="mt-4 space-y-2">
          {data.top.map((r, i) => (
            <div key={i} className={`flex items-center gap-3 rounded-xl px-4 py-2.5 ${dark ? 'bg-white/[0.03]' : 'bg-neutral-50'}`} data-testid={`aff-leaderboard-row-${i}`}>
              <span className="w-7 text-center text-[15px]">{medal(i)}</span>
              <div className="flex-1 min-w-0">
                <p className={`text-[13.5px] font-semibold truncate ${txt}`}>{r.name}</p>
                <p className={`text-[11px] ${sub}`}>{[r.city, r.country].filter(Boolean).join(', ') || '—'} · {r.tier}</p>
              </div>
              <div className="flex flex-col items-end">
                <p className={`text-[13px] font-bold tabular-nums ${txt}`}>{r.customers} <span className={`font-normal text-[11px] ${sub}`}>{c.customers}</span></p>
                {r.pace ? (
                  <span className="mt-0.5 inline-flex items-center gap-0.5 text-[10px] font-bold text-emerald-500 bg-emerald-500/10 rounded-full px-2 py-0.5" data-testid={`aff-leaderboard-pace-${i}`}>
                    ↑ +{r.pace}{c.perMonth}
                  </span>
                ) : null}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
